<template>
  <div class="is-fullwidth">
    <button
      :class="button_class"
      type="button"
      @click.prevent="addToCart({ product_id, quantity })"
    >
      <i class="fa fa-shopping-cart" style="margin-right: 10px;"></i>
      <span>Add to cart</span>
    </button>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'AddToCartButton',

  props: {
    button_class: {
      required: false,
      type: String,
      default: 'button is-info is-outlined is-medium'
    },
    product_id: { required: true, type: String },
    quantity: { required: false, type: Number, default: 1 }
  },

  methods: mapActions(['addToCart'])
};
</script>
